




































import VueOptions from '@utils/VueOptions'

settings =
  name: 'SignUpForm'

  vue:
    props: ['data']

    data: ->
      validatePassword = (rule, value, callback) =>
        if '' isnt @data.social_presence.password_confirmation
          @$refs.signUpForm.validateField 'password_confirmation'
        callback()

      validatePasswordConfirmation = (rule, value, callback) =>
        if value isnt @data.social_presence.password
          return callback new Error('Passwords do not match!')
        callback()

      rules:
        password: [
          { required: true, message: 'Create your password.' },
          { validator: validatePassword, trigger: 'blur' },
        ]
        password_confirmation: [
          { required: true, message: 'Confirm your password.' },
          { validator: validatePasswordConfirmation, trigger: 'blur' },
        ]

export default VueOptions.vue settings
